import axios from 'axios'

// Configurar axios para localhost
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://localhost:7209/api/',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

const API_BASE_URL = '/Asignacion'

const asignacionesService = {
  // Obtener todas las asignaciones
  async getAll() {
    try {
      console.log('📋 Obteniendo asignaciones desde API...')
      const response = await api.get(API_BASE_URL)
      console.log('📋 Asignaciones cargadas desde API:', response.data.length)
      return response.data
    } catch (error) {
      console.error('Error loading assignments from API:', error)
      return []
    }
  },

  // Obtener asignación por ID
  async getById(id) {
    try {
      const response = await api.get(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error loading assignment by ID:', error)
      throw error
    }
  },

  // Crear nueva asignación
  async create(assignmentData) {
    try {
      console.log('💾 Creando asignación en API...', assignmentData)

      // Formatear datos según AsignacionCreateDto
      const createDto = {
        programacionAcademicaId: assignmentData.programacionAcademicaId,
        cursoId: assignmentData.cursoId,
        catedraticoId: assignmentData.catedraticoId,
        salonId: assignmentData.salonId,
        diaSemana: assignmentData.diaSemana,
        horaInicio: assignmentData.horaInicio,
        horaFin: assignmentData.horaFin,
        seccion: assignmentData.codigoSeccion || assignmentData.seccion || 'A',
        observaciones: assignmentData.observaciones || '',
        estado: 'Activo' // Siempre string, no boolean
      }

      console.log('📤 Enviando createDto:', createDto)

      const response = await api.post(API_BASE_URL, createDto)
      console.log('✅ Asignación creada en API:', response.data)
      return response.data
    } catch (error) {
      console.error('Error creating assignment in API:', error)
      throw error
    }
  },

  // Actualizar asignación
  async update(assignmentData) {
    try {
      console.log('🔄 Actualizando asignación en API...', assignmentData)
      
      const response = await api.put(`${API_BASE_URL}/${assignmentData.asignacionId}`, assignmentData)
      console.log('✅ Asignación actualizada en API')
      return response.data
    } catch (error) {
      console.error('Error updating assignment in API:', error)
      throw error
    }
  },

  // Eliminar asignación
  async delete(assignmentId) {
    try {
      console.log('🗑️ Eliminando asignación de la API...', assignmentId)
      
      await api.delete(`${API_BASE_URL}/${assignmentId}`)
      console.log('✅ Asignación eliminada de la API')
      return true
    } catch (error) {
      console.error('Error deleting assignment from API:', error)
      throw error
    }
  },

  // Verificar conflictos (placeholder)
  async checkConflicts(assignmentData) {
    console.warn('⚠️ Verificación de conflictos no implementada en el backend')
    return { hasConflicts: false, conflicts: [] }
  }
}

export default asignacionesService